import React from "react";
import { useParams } from "react-router-dom";
import ClockScreen from "./ClockScreen";

export default function Mobile() {
  const { companyId } = useParams();
  return <ClockScreen mode="mobile" fixedCompanyId={companyId} />;
}
